import { apiConfig } from "../apiConfig"
import useFetchClient from "./useFetchClient"
import { useAppDispatch } from "../redux/hooks";
import { 
    loading, 
    companyGroupFetched, 
    companyGroupFetchFailure
} from "../redux/slices/companyGroupSlice";
import { CompanyGroup } from "../redux/types";

const useCompanyGroupActions = () => {
    const fetchClient = useFetchClient()
    const dispatch = useAppDispatch()

    const getCompanyGroup = () => {
        dispatch(loading())

        return fetchClient.get(apiConfig.routes.companyGroup)
            .then(response => {
                dispatch(companyGroupFetched(response.data as CompanyGroup))
            })
            .catch(error => {
                console.log('getCompanyGroup error:', error)
                dispatch(companyGroupFetchFailure(error))
            })
    }

    return {
        getCompanyGroup
    }
}

export default useCompanyGroupActions